// Helper to compute the marginal tax rate from taxable income and tax bands.
export const computeMarginalRate = (taxable, bands) => {
  if (!bands || bands.length === 0) {
    return 0;
  }
  
  let remaining = taxable;
  for (const band of bands) {
    // Use remaining if band.breadth is Infinity.
    const bandBreadth = band.breadth === Infinity ? remaining : band.breadth;
    if (remaining <= bandBreadth) {
      return band.rate;
    }
    remaining -= bandBreadth;
  }
  return bands[bands.length - 1]?.rate || 0;
};